import React, { useState, useEffect } from 'react';
import {
  Box, Button, Input, Text, Select, Spinner, FormLabel, Checkbox, useToast
} from "@chakra-ui/react";
import { theme } from "../../styles/theme";
import { api } from "../../services/api";
import $ from 'jquery';
import { CardNumberInputMask } from '../CardNumberInputMask';
import { CardVerificationInputMask } from '../CardVerificationInputMask';
import { CardExpirationInputMask } from '../CardExpirationInputMask';
import { BoozenToast } from '../BoozenToast';




export function CardFormPayment({
    payment,
    batchOrders,
    setCardSubmitted,
    updateInvoiceStatus
  }) {
  const toast = useToast();
  const showToast = (type, title, description) => {
    toast({
      render: ({ onClose }) => (
        <BoozenToast type={type} title={title} description={description} onClose={onClose} />
      ),
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  };

  const [showPaymentLoading, setShowPaymentLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [saveCard, setSaveCard] = useState("off");
  const [savedCards, setSavedCards] = useState([]);
  const [cardUsed, setCardUsed] = useState("new");
  const [selectedSavedCard, setSelectedSavedCard] = useState(null);
  const [cardData, setCardData] = useState({
    number: '',
    verificationValue: '',
    fullName: '',
    expirationMonth: '',
    expirationYear: '',
    numberOfInstallments: ''
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCardData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleCheckboxChange = (event) => {
    setSaveCard(event.target.checked ? "on" : "off");
  };

  // useEffect(() => {
  //   api.get('/api/v1/payments/saved_cards').then((response) => {
  //     if (!response.data.mesage) {
  //       setSavedCards(response.data.saved_cards);
  //     } else {
  //       setSavedCards([]);
  //     }
  //   }).catch(() => {
  //     setSavedCards([]);
  //   });
  // }, []);

  useEffect(() => {
    const loadIuguScript = () => {
      if (document.querySelector("#payment-form")) {
        const script = document.createElement("script");
        script.src = "https://js.iugu.com/v2";
        script.onload = () => {
          const iugu = window.Iugu;
          iugu.setAccountID("FA1E8C4E4554443EAE03F5C94A781AAB");
          iugu.setTestMode(process.env.NODE_ENV === 'development');

          $("#payment-form").on("submit", function (event) {
            event.preventDefault();

            const form = $(this);

            // Detect brand from card number prefix
            const rawNumber = form.find('[data-iugu="number"]').val().replace(/\D/g, '');
            const cvv       = form.find('[data-iugu="verification_value"]').val();

            function detectBrand(n) {
              if (/^3[47]/.test(n))                                   return 'amex';
              if (/^4/.test(n))                                        return 'visa';
              if (/^(5[1-5]|2[2-7]\d{2})/.test(n))                   return 'mastercard';
              if (/^(36|38|30[0-5])/.test(n))                         return 'diners';
              if (/^(606282|3841[046]|637(095|568|599|609|612))/.test(n)) return 'hipercard';
              if (/^(4011|438935|4576|504175|5067|509|636368|636297)/.test(n)) return 'elo';
              return null;
            }

            const brand = detectBrand(rawNumber);

            if (!iugu.utils.validateCreditCardNumber(rawNumber)) {
              showToast("error", "Cartão inválido", "Verifique o número do cartão e tente novamente.");
              return false;
            }

            if (brand && !iugu.utils.validateCVV(cvv, brand)) {
              const expectedDigits = brand === 'amex' ? 4 : 3;
              showToast("error", "Código de segurança inválido", `Cartões ${brand.toUpperCase()} têm ${expectedDigits} dígitos.`);
              return false;
            }

            setShowPaymentLoading(true);

            const tokenResponseHandler = (data) => {
              if (data.errors) {
                const msgs = {
                  number:             'Número do cartão inválido.',
                  verification_value: 'Código de segurança inválido.',
                  expiration:         'Data de validade inválida.',
                  last_name:          'Nome do titular inválido.',
                  first_name:         'Nome do titular inválido.',
                };
                const first = Object.keys(data.errors)[0];
                showToast("error", "Erro no cartão", msgs[first] || "Verifique os dados e tente novamente.");
                setShowPaymentLoading(false);
              } else {
                $("#token").val(data.id);
                const regex = /\/(\d+)$/;
                const match = window.location.pathname.match(regex);
                const paymentId = match[1];
                const selectElement = document.getElementsByName('numberOfInstallments')[0];
                const installments = selectElement ? selectElement.value : 1;
                // api.post(`/api/v1/payments/${paymentId}/pay_with_card`, {
                //   token: data.id,
                //   number_of_installments: installments
                // }).then(response => {
                //   console.log("OK");
                // }).catch(error => {

                //   console.error("Error submitting payment:", error);
                // });
                api.post(`/api/v1/payments/${paymentId}/pay_with_card`, {
                  token: data.id,
                  number_of_installments: installments
                })
                .then(async (response) => {
                  setCardSubmitted(true);
                  setTimeout(() => {
                    updateInvoiceStatus();
                  }, 5000);

                })
                .catch(error => {

                  setShowPaymentLoading(false);

                  console.error(
                    "Error submitting payment:",
                    error
                  );

                  showToast("error", "Erro no pagamento", "Não foi possível processar o pagamento. Tente novamente.");

                });

                if (window && window.gtag) {
                  window.gtag("event", "purchase", {
                    transaction_id: payment.id,
                    value: ((payment.price_in_cents ?? 0) / 100).toFixed(2),
                    currency: "BRL",
                    items: batchOrders.map((item) => ({
                      item_id: item.id,
                      price: item.amount,
                      quantity: item.quantity
                    }))
                  });
                }
              }
            };

            iugu.createPaymentToken(this, tokenResponseHandler);
            return false;
          });
        };
        document.body.appendChild(script);
      }
    };

    loadIuguScript();

    return () => {
      const script = document.querySelector("script[src='https://js.iugu.com/v2']");
      if (script) script.remove();
      $("#payment-form").off("submit");
    };
  }, [saveCard, batchOrders]);


  const handleCardUsedChange = (type) => setCardUsed(type);
  const handleSavedCardSelection = (e) => setSelectedSavedCard(e.target.value)


  // const handlePayment = async (event) => {
  //   event.preventDefault(); // Prevent default form submission
  //   setShowPaymentLoading(true);

  //   try {
  //     const response = await api.post(`/api/v1/payments/${payment.id}/pay_with_saved_card`, {
  //       savedCard: selectedSavedCard,
  //       numberOfInstallments: cardData.numberOfInstallments
  //     });

  //     if (response.data.message === "Pagamento aprovado") {
  //       console.log('Payment successful');
  //       const items = batchOrders.map(item => ({
  //         item_id: item.id,
  //         price: item.amount,
  //         quantity: item.quantity
  //       }));
  //       if (window && window.gtag) {
  //         window.gtag("event", "purchase", {
  //           transaction_id: payment.id,
  //           value: (payment.price_in_cents / 100).toFixed(2),
  //           currency: "BRL",
  //           items: items
  //         });
  //       }
  //     } else {
  //       console.error('Payment failed:', response.data.message);
  //       alert(response.data.message);
  //     }
  //   } catch (error) {
  //     console.error('Payment error:', error);
  //     alert('Ocorreu um erro ao processar o pagamento. Tente novamente mais tarde.');
  //   } finally {
  //     setShowPaymentLoading(false);
  //   }
  // };

  const handlePayment = async (event) => {
    event.preventDefault();

    setShowPaymentLoading(true);

    try {

      const response = await api.post(
        `/api/v1/payments/${payment.id}/pay_with_card`,
        {
          savedCard: selectedSavedCard,
          numberOfInstallments: cardData.numberOfInstallments
        }
      );

      if (response.data.message === "Pagamento aprovado") {

        const items = batchOrders.map(item => ({
          item_id: item.id,
          price: item.amount,
          quantity: item.quantity
        }));

        if (window && window.gtag) {
          window.gtag("event", "purchase", {
            transaction_id: payment.id,
            value: (payment.price_in_cents / 100).toFixed(2),
            currency: "BRL",
            items
          });
        }

        // aguarda processamento da Iugu
        await new Promise(resolve => setTimeout(resolve, 5000));

        // consulta status atualizado
        const invoiceResponse = await api.get(
          `/api/v1/payments/${payment.id}/invoice_status`
        );

        if (invoiceResponse.data.invoice.status === "paid") {

          window.location.href =
            `/perfil/${payment.user_id}?payment_success=true`;

        } else {

          showToast("info", "Pagamento em processamento", "Aguarde alguns instantes enquanto confirmamos seu pagamento.");

        }

      } else {

        console.error(
          "Payment failed:",
          response.data.message
        );

        showToast("error", "Pagamento recusado", response.data.message || "Não foi possível processar o pagamento.");

      }

    } catch (error) {

      console.error("Payment error:", error);

      showToast("error", "Erro inesperado", "Ocorreu um erro ao processar o pagamento. Tente novamente.");

    } finally {

      setShowPaymentLoading(false);

    }
  };

  return (
    <>
      <Box
        margin="0"
        width={{base: '100%', md: '100%'}}
        border={`1px solid rgba(0, 74, 51, 0.08)`}
        boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
        borderRadius="16px"
        bg="white"
        overflow="hidden"
        h="100%"
        display="flex"
        flexDirection="column"
      >
        <Box
          bg={`linear-gradient(135deg, ${theme.colors.primaryOrange} 0%, rgba(252, 143, 4, 0.95) 100%)`}
          p="16px 20px"
        >
          <Text fontSize="20px" fontWeight="900" color={theme.colors.primaryGreen}>
            Cartão de crédito
          </Text>
        </Box>
        <Box p={{ base: "20px", md: "28px" }}>
          <Box
            bg="transparent"
            border="2px solid #004a33"
            borderRadius="16px"
            p="20px"
          >
            <Text
              fontSize="22px"
              fontWeight="900"
              color="#004a33"
            >
              Pagamento Seguro
            </Text>

            <Text
              color="rgba(25, 73, 5, 0.75)"
              fontSize="13px"
              mt="2px"
            >
              Seus dados são protegidos e criptografados
            </Text>
          </Box>

          <form id="payment-form" action={`${process.env.REACT_APP_API_URL}payments/${payment.id}/pay_with_card`} method="post">
            <FormLabel
              marginTop={"20px"}
              htmlFor="fullName"
              fontSize="12px"
              fontWeight="800"
              color="gray.600"
              textTransform="uppercase"
              letterSpacing=".5px"
              mb="6px"
            >
              NOME NO CARTÃO
            </FormLabel>
            <Input
              id='fullName'
              borderColor={theme.colors.lightGray}
              name="fullName"
              value={cardData.fullName}
              onChange={handleInputChange}
              data-iugu="full_name"
              h="54px"
              borderRadius="14px"
              fontSize="15px"
              _focus={{
                borderColor: theme.colors.primaryGreen,
                boxShadow: `0 0 0 1px ${theme.colors.primaryGreen}`
              }}
              _hover={{
                borderColor: theme.colors.lightGray
              }}
            />
            <FormLabel
              marginTop={"10px"}
              marginBottom={"0"}
              htmlFor="number"
              fontSize="12px"
              fontWeight="800"
              color="gray.600"
              textTransform="uppercase"
              letterSpacing=".5px"
              mb="6px"
            >
              NÚMERO DO CARTÃO
            </FormLabel>
            <CardNumberInputMask maskType="cardNumber" placeholder="1234 5678 9012 3456" />
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              gap={"20px"}
            >
              <Box>
                <FormLabel
                  marginTop={"10px"}
                  marginBottom={"0"}
                  htmlFor="varificationValue"
                  fontSize="12px"
                  fontWeight="800"
                  color="gray.600"
                  textTransform="uppercase"
                  letterSpacing=".5px"
                  mb="6px"
                >
                  CSV
                </FormLabel>
                <CardVerificationInputMask placeholder="123" />
              </Box>
              <Box>
                <FormLabel
                  marginTop={"10px"}
                  marginBottom={"0"}
                  htmlFor="expiration"
                  fontSize="12px"
                  fontWeight="800"
                  color="gray.600"
                  textTransform="uppercase"
                  letterSpacing=".5px"
                  mb="6px"
                >
                  VALIDADE
                </FormLabel>
                <Box
                  display={"flex"}
                  gap={"10px"}
                >
                  <CardExpirationInputMask maskType="date" placeholder="MM/AA"/>
                </Box>
              </Box>
            </Box>
            <FormLabel
              marginTop={"10px"}
              marginBottom={"0"}
              htmlFor="expiration"
              fontSize="12px"
              fontWeight="800"
              color="gray.600"
              textTransform="uppercase"
              letterSpacing=".5px"
              mb="6px"
            >
              PARCELAS
            </FormLabel>
            <Select
              id='numberOfInstallments'
              borderColor={theme.colors.lightGray}
              name="numberOfInstallments"
              value={cardData.numberOfInstallments}
              data-iugu='installments'
              onChange={handleInputChange}
              h="54px"
              borderRadius="14px"
              bg="white"
              _hover={{
                borderColor: theme.colors.lightGray
              }}
            >
              <option value=''></option>
              <option value='1'>1 parcela de {(payment.price_in_cents / 100).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} sem juros</option>
              <option value='2'>2 parcelas de {((payment.price_in_cents / 100) / 2).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} sem juros</option>
              <option value='3'>3 parcelas de {((payment.price_in_cents / 100) / 3).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} sem juros </option>
              <option value='4'>4 parcelas de {((payment.price_in_cents / 100) / 4).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} sem juros </option>
            </Select>
            <Box display={"none"}>
              <FormLabel
                marginTop={"10px"}
                marginBottom={"0"}
                htmlFor="token"
              >
                Token do Cartão de Crédito - Enviar para seu Servidor
              </FormLabel>
              <Input
                type="text"
                name="token"
                id="token"
                value=""
                readOnly={true}
              />
            </Box>
            {/* <Checkbox
              isChecked={saveCard === "on"}
              onChange={handleCheckboxChange}
              marginTop="20px"
            >
              Salvar cartão para próximas compras
            </Checkbox> */}
            {!showPaymentLoading && (
              <Button
                id="submit"
                width="100%"
                margin="20px auto"
                type="submit"
                disabled={isLoading}
                bg={theme.colors.primaryGreen}
                color={theme.colors.primaryOrange}
                borderRadius="16px"
                border={`1px solid ${theme.colors.primaryGreen}`}
                _hover={{
                  background: "transparent",
                  color: `${theme.colors.primaryGreen}`,
                  borderCorlor: `${theme.colors.primaryOrange}`
                }}
              >
                Pagar
              </Button>
            )}
            <Box
              mt="20px"
              textAlign="center"
            >
              <Text
                fontSize="12px"
                color="gray.500"
              >
                🔒 Pagamento processado em ambiente seguro
              </Text>
            </Box>
            {showPaymentLoading && (
              <Box margin="20px 37.5%" display='flex' justifyContent='center' alignItems='center'>
                <Spinner id="spinner" color={theme.colors.primary} />
              </Box>
            )}
          </form>
        </Box>
      </Box>

    </>
  );
}
